import { render, staticRenderFns } from "./RGPD.vue?vue&type=template&id=9f678bae&"
import script from "./RGPD.vue?vue&type=script&lang=js&"
export * from "./RGPD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports